import { Reducer } from 'redux';
import { AuthState, AuthTypes } from './types';

const INITIAL_STATE: AuthState = {
  forgotPasswordMessage: '',
  token: '',
  errorMessage: '',
  loginError: false,
  loginLoading: false,
  passwordLoading: false,
  passwordError: false,
  passwordResetLoading: false,
  passwordResetError: false,
  user: undefined,
  logoutLoading: false,
  logoutError: false,
  inscricaoAtiva: undefined,
  cddAtivo: undefined,
  depositanteAtiva: undefined,
};

const reducer: Reducer<AuthState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AuthTypes.LOGIN_REQUEST:
      return {
        ...state,
        loginLoading: true,
      };
    case AuthTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loginLoading: false,
        loginError: false,
        token: action.payload.token,
        user: action.payload.user,
      };
    case AuthTypes.LOGIN_FAILURE:
      return {
        ...state,
        loginLoading: false,
        loginError: true,
        token: '',
        errorMessage: action.payload.errorMessage,
      };

    case AuthTypes.UPDATE_REQUEST:
      return {
        ...state,
        loginLoading: true,
      };
    case AuthTypes.UPDATE_SUCCESS:
      return {
        ...state,
        loginLoading: false,
        loginError: false,
        token: action.payload.token,
      };
    case AuthTypes.UPDATE_FAILURE:
      return {
        ...state,
        loginLoading: false,
        loginError: true,
        token: '',
        errorMessage: action.payload.errorMessage,
      };

    case AuthTypes.PASSWORD_REQUEST:
      return {
        ...state,
        passwordLoading: true,
        passwordError: false,
      };
    case AuthTypes.PASSWORD_SUCCESS:
      return {
        ...state,
        passwordLoading: false,
        passwordError: false,
        forgotPasswordMessage: action.payload.forgotPasswordMessage,
      };
    case AuthTypes.PASSWORD_FAILURE:
      return {
        ...state,
        passwordLoading: false,
        passwordError: true,
        forgotPasswordMessage: '',
        errorMessage: action.payload.errorMessage,
      };

    case AuthTypes.PASSWORDRESET_REQUEST:
      return {
        ...state,
        passwordResetLoading: true,
        passwordResetError: false,
      };
    case AuthTypes.PASSWORDRESET_SUCCESS:
      return {
        ...state,
        passwordResetLoading: false,
        passwordResetError: false,
      };
    case AuthTypes.PASSWORDRESET_FAILURE:
      return {
        ...state,
        passwordResetLoading: false,
        passwordResetError: true,
        errorMessage: action.payload.errorMessage,
      };

    case AuthTypes.LOGOUT_REQUEST:
      return {
        ...state,
        logoutLoading: true,
      };
    case AuthTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        logoutLoading: false,
        logoutnError: false,
      };
    case AuthTypes.LOGOUT_FAILURE:
      return {
        ...state,
        logoutLoading: false,
        logoutError: true,
        token: '',
        errorMessage: action.payload.errorMessage,
      };
    case AuthTypes.INSC_SELECT:
      return {
        ...state,
        inscricaoAtiva: action.payload.inscricaoAtiva,
      };
    case AuthTypes.CDD_SELECT:
      return {
        ...state,
        cddAtivo: action.payload.cddAtivo,
      };
    case AuthTypes.UPDATE_PROFILE:
      return {
        ...state,
      };
    case AuthTypes.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        user: action.payload.profile,
      };
    case AuthTypes.DEP_SELECT:
      return {
        ...state,
        depositanteAtiva: action.payload.depositanteAtiva,
      };

    case AuthTypes.CLEAN_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
